import FnrFetch2 from "Utilities/FnrFetch/FnrFetch2.js";
import FnrEnvironment from "Utilities/FnrEnvironment";
import devAPI from "./API.dev.js";

let API = {
  getUserInfo: (userID) => new FnrFetch2("/family/getUserInfo", { userID }),

  createNewUser: (groupID, data) =>
    new FnrFetch2("/group/" + groupID + "/addToGroupByHouseholdUser", data),

  getAddFamilyMemberData: ({ profileUserID, relationshipUserID }) =>
    new FnrFetch2("/family/getAddFamilyMemberData", {
      profileUserID,
      relationshipUserID,
    }),

  saveRelationship: (data) => new FnrFetch2("/family/createRelationship", data),

  getHouseholdData: (userID) =>
    new FnrFetch2("/family/getHouseholdDataForProfile", { userID }),

  updateHouseholdName: (userID, name) =>
    new FnrFetch2("/people/" + userID + "/updateHouseholdName", { name }),

  removeFromHousehold: (userID) =>
    new FnrFetch2("/people/" + userID + "/removeMemberFromHousehold", {
      userToRemoveID: userID,
    }),

  updateHeadOfHousehold: (userID, on) =>
    new FnrFetch2("/user/" + userID + "/updatePriv", {
      priv: "headOfHousehold",
      on,
    }),

  searchForMoreHouseholdMembers: ({ searchTerm, excludeUserID, lname }) =>
    new FnrFetch2("/supersearch/householdMembers", {
      searchTerm,
      excludeUserID,
      lname,
    }),
  checkForPendingRelationshipConflicts: (postData) =>
    new FnrFetch2(
      "/familyconfirmation/checkForPendingRelationshipConflicts",
      postData
    ),
  confirmPendingRelationship: (postData) =>
    new FnrFetch2("/familyconfirmation/confirmPendingRelationship", postData),
  cancelPendingRelationship: (postData) =>
    new FnrFetch2("/familyconfirmation/cancelPendingRelationship", postData),
  getAllProxyContacts: (postData) =>
    new FnrFetch2("/proxycontact/getAllProxyContacts", postData),
  createProxyContact: (postData) =>
    new FnrFetch2("/proxycontact/create", postData),
  deleteProxyContact: (postData) =>
    new FnrFetch2("/proxycontact/delete", postData),
};

if (FnrEnvironment.shouldUseDevAPI()) API = { ...API, ...devAPI };

export default API;
